import { obtenerFechaActualLocal, fechaLocalConOffset } from './dateUtils';

/**
 * Presets de rango para el kardex (PROMPT_N°053).
 *
 * Todos salen de los helpers del N°048, en hora local: con
 * `toISOString()` el preset "Hoy" después de las 21:00 en Chile habría
 * apuntado a mañana.
 */
export type PresetRango =
  | 'hoy'
  | 'ayer'
  | 'semana'
  | 'ultimos7'
  | 'mes'
  | 'personalizado';

export interface Rango {
  desde: string;
  hasta: string;
}

export const ETIQUETAS_PRESET: Record<PresetRango, string> = {
  hoy: 'Hoy',
  ayer: 'Ayer',
  semana: 'Esta semana',
  ultimos7: 'Últimos 7 días',
  mes: 'Este mes',
  personalizado: 'Personalizado',
};

/** Lunes de la semana en curso, en hora local. */
const lunesDeEstaSemana = (): string => {
  const d = new Date();
  // getDay(): 0 = domingo. La semana laboral chilena arranca el lunes.
  const diasDesdeLunes = (d.getDay() + 6) % 7;
  return fechaLocalConOffset(-diasDesdeLunes);
};

const primeroDelMes = (): string => {
  const d = new Date();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  return `${d.getFullYear()}-${mes}-01`;
};

export const rangoDePreset = (preset: PresetRango): Rango => {
  const hoy = obtenerFechaActualLocal();
  switch (preset) {
    case 'hoy':
      return { desde: hoy, hasta: hoy };
    case 'ayer': {
      const ayer = fechaLocalConOffset(-1);
      return { desde: ayer, hasta: ayer };
    }
    case 'semana':
      return { desde: lunesDeEstaSemana(), hasta: hoy };
    case 'ultimos7':
      // Incluye hoy: 6 días atrás + hoy = 7 días.
      return { desde: fechaLocalConOffset(-6), hasta: hoy };
    case 'mes':
      return { desde: primeroDelMes(), hasta: hoy };
    case 'personalizado':
    default:
      return { desde: fechaLocalConOffset(-6), hasta: hoy };
  }
};

/** Qué preset corresponde a un rango, o 'personalizado' si no calza con ninguno. */
export const presetDeRango = (rango: Rango): PresetRango => {
  const candidatos: PresetRango[] = ['hoy', 'ayer', 'semana', 'ultimos7', 'mes'];
  for (const p of candidatos) {
    const r = rangoDePreset(p);
    if (r.desde === rango.desde && r.hasta === rango.hasta) return p;
  }
  return 'personalizado';
};
